import { useEffect, useState } from 'react';

/**
 * Trì hoãn cập nhật `value` — dùng cho gọi API / turf sau khi user kéo xong / tạm dừng.
 */
export function useDebouncedValue<T>(value: T, ms: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = window.setTimeout(() => setDebounced(value), ms);
    return () => window.clearTimeout(t);
  }, [value, ms]);
  return debounced;
}
